module.exports = __webpack_public_path__ + "static/img/card_icon_task@2x.f56f3b39.png";